import {
  Link,
  createTableColumn,
  TableColumnDefinition,
  Button,
} from "@fluentui/react-components";
import i18n from "i18next";
import { IKonfigurationSt } from "../../Models/IKonfigurationSt";
import {
  DeleteRegular,
  LockClosedRegular,
  PeopleTeamRegular,
} from "@fluentui/react-icons";

interface IColumnsConfiSTProps {
  openDialogWithConfig(item: IKonfigurationSt): void;
  onFreigabeObjectGuid(item: string): void;
  onDeleteGuid(item: string): void;
}

export function ColumnsConfiST(props: IColumnsConfiSTProps) {
  const columns: TableColumnDefinition<IKonfigurationSt>[] = [
    createTableColumn<IKonfigurationSt>({
      columnId: "id",
      compare: (a, b) => {
        if (a.id && b.id) {
          return a.id.localeCompare(b.id);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "ID";
      },
      renderCell: (item) => {
        return (
          <Link
            onClick={() => {
              props.openDialogWithConfig(item);
            }}
          >
            {item.id}
          </Link>
        );
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "actionsId",
      compare: (a, b) => {
        if (a.canDeleteObject && a.hasFreigaben) {
          return 4;
        } else if (a.canDeleteObject && !a.hasFreigaben) {
          return 3;
        } else if (!a.canDeleteObject && a.hasFreigaben) {
          return 2;
        } else return 1;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("actions");
      },
      renderCell: (item) => {
        return (
          <>
            <Button
              appearance="transparent"
              onClick={() => {
                if (item.userObjectGuid) {
                  props.onFreigabeObjectGuid(item.userObjectGuid);
                }
              }}
              icon={
                item.hasFreigaben ? (
                  <PeopleTeamRegular color="#ff6600" />
                ) : (
                  <LockClosedRegular color="#ff6600" />
                )
              }
            />
            {item?.canDeleteObject != undefined && item?.canDeleteObject && (
              <Button
                appearance="transparent"
                icon={<DeleteRegular color="#ff6600" />}
                onClick={() => {
                  if (item.userObjectGuid) {
                    props.onDeleteGuid(item.userObjectGuid);
                  }
                }}
              />
            )}
          </>
        );
      },
    }),

    createTableColumn<IKonfigurationSt>({
      columnId: "kommentar",
      compare: (a, b) => {
        if (a.kommentar && b.kommentar) {
          return a.kommentar.localeCompare(b.kommentar);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("kommentar");
      },
      renderCell: (item) => {
        return <div>{item.kommentar}</div>;
      },
    }),

    createTableColumn<IKonfigurationSt>({
      columnId: "status",
      compare: (a, b) => {
        if (a.status && b.status) {
          return a.status - b.status;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("status");
      },
      renderCell: (item) => {
        return i18n.t<string>("configStatus" + item.status);
      },
    }),

    createTableColumn<IKonfigurationSt>({
      columnId: i18n.language.includes("de")
        ? "positionen[0].artikel?.benennungDE"
        : "positionen[0].artikel?.benennungEN",
      compare: (a, b) => {
        if (
          a.positionen[0].artikel?.benennungDE &&
          b.positionen[0].artikel?.benennungDE
        ) {
          if (i18n.language.includes("de")) {
            return a.positionen[0].artikel?.benennungDE.localeCompare(
              b.positionen[0].artikel?.benennungDE,
            );
          } else if (
            a.positionen[0].artikel?.benennungEN != undefined &&
            b.positionen[0].artikel?.benennungEN != undefined
          ) {
            return a.positionen[0].artikel?.benennungEN.localeCompare(
              b.positionen[0].artikel?.benennungEN,
            );
          } else return 0;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("schraubsystem");
      },
      renderCell: (item) => {
        if (item.positionen?.length > 0) {
          return (
            <div className="lueb-centerVertical">
              {i18n.language.includes("de")
                ? item.positionen[0].artikel?.benennungDE
                : item.positionen[0].artikel?.benennungEN}
            </div>
          );
        }
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "GesendetVonId",

      renderHeaderCell: () => {
        return i18n.t<string>("sentBy");
      },
      renderCell: (item) => {
        return item.gesendetVon?.fullName;
      },
    }),
    createTableColumn<IKonfigurationSt>({
      columnId: "gesendetAm",

      renderHeaderCell: () => {
        return i18n.t<string>("sentOn");
      },
      renderCell: (item) => {
        if (typeof item.gesendetAm == "string") {
          return new Date(item.gesendetAm).toLocaleString();
        }
      },
    }),
  ];

  return columns;
}
